import React from 'react';
import PropTypes from 'prop-types';
import { Section, Container, Typography } from 'components/base';
import { CloudinaryPicture, PrismicHtmlContent, PrismicSlices } from 'components/rich';

import { Head, Layout } from '../../components/layout';

export const CONTENT_PAGES = {
  '/about': 'about',
  '/privacy': 'privacy',
  '/terms': 'termsofuse',
  '/wholesale': 'wholesale',
};

const ContentPage = props => {
  return (
    <React.Fragment key={props.contentId}>
      <Head title={props.pageTitle} />

      <Layout>
        <Section>
          <Container className="mw-800">
            {props.pageCaption && <Typography.H1>{props.pageCaption}</Typography.H1>}
            {props.imageKey && (
              <CloudinaryPicture imageKey={props.imageKey} className="mt-2 mb-2 d-block mw-100" />
            )}
            <PrismicHtmlContent content={props.body} />
            <PrismicSlices slices={props.slices} />
          </Container>
        </Section>
      </Layout>
    </React.Fragment>
  );
};

ContentPage.getInitialProps = async () => {
  throw new Error('Cannot access this page directly. See /[...params] page');
};

ContentPage.propTypes = {
  contentId: PropTypes.string,
  imageKey: PropTypes.string,
  pageTitle: PropTypes.string,
  pageCaption: PropTypes.string,
  body: PropTypes.any,
  slices: PropTypes.array,
};

export default ContentPage;
